import i18next from 'i18next';

import { ApplicationMethodTypeId } from 'src/app/pages/marketing/discounts/wizard-refactor/wizard/types';
import { Features } from 'src/app/state/types/loc-profile';
import { useFeatureCheck } from 'src/app/state/user-dispensaries';

export const applicationMethodNames: Record<ApplicationMethodTypeId, string> = {
  [ApplicationMethodTypeId.Automatically]: i18next.t('Automatic'),
  [ApplicationMethodTypeId.Manually]: i18next.t('Manual'),
  [ApplicationMethodTypeId.ByCode]: i18next.t('Code'),
  [ApplicationMethodTypeId.BySpringBig]: i18next.t('SpringBig'),
  [ApplicationMethodTypeId.ByAlpineIQ]: i18next.t('Alpine IQ'),
  [ApplicationMethodTypeId.ByFyllo]: i18next.t('Fyllo'),
  [ApplicationMethodTypeId.ExternalLoyalty]: i18next.t('External loyalty'),
  [ApplicationMethodTypeId.DutchieLoyalty]: i18next.t('Loyalty'),
};

export function useApplicationMethods() {
  const applicationMethods = [
    ApplicationMethodTypeId.Automatically,
    ApplicationMethodTypeId.Manually,
    ApplicationMethodTypeId.ByCode,
  ];

  const springBigEnabled = useFeatureCheck(Features.UseSpringBig);
  if (springBigEnabled) {
    applicationMethods.push(ApplicationMethodTypeId.BySpringBig);
  }

  const alpineIqEnabled = useFeatureCheck(Features.UseAlpineIQ);
  if (alpineIqEnabled) {
    applicationMethods.push(ApplicationMethodTypeId.ByAlpineIQ);
  }

  const fylloEnabled = useFeatureCheck(Features.UseFyllo);
  if (fylloEnabled) {
    applicationMethods.push(ApplicationMethodTypeId.ByFyllo);
  }

  const externalLoyaltyEnabled = useFeatureCheck(Features.ShowExternalLoyalty);
  if (externalLoyaltyEnabled) {
    applicationMethods.push(ApplicationMethodTypeId.ExternalLoyalty);
  }

  const dutchieLoyaltyEnabled = useFeatureCheck(Features.ShowLeafLogixLoyalty);
  if (dutchieLoyaltyEnabled) {
    applicationMethods.push(ApplicationMethodTypeId.DutchieLoyalty);
  }

  return applicationMethods;
}
